import PropTypes from 'prop-types';
import { registerFormValidationErrorType } from 'modules/general/enums';
import generalStrings from 'modules/general/strings';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  FormWrapper,
  FormLabel,
  FormTextInput,
  FormFieldWrapper,
  FormValidationError,
} from './AccountInformation.style';

const AccountInformation = ({
  formFieldsValues,
  formFieldsValidation,
  handleTextInputFieldChange,
}) => (
  <FormWrapper>
    {/* Account Name Field */}
    <FormFieldWrapper>
      <FormLabel>{`${generalStrings.registerForm.formAccountNameFieldLabel}*`}</FormLabel>
      <SectionDivider gap={4} />
      <FormTextInput
        type="text"
        value={formFieldsValues.accountName}
        onChange={event => handleTextInputFieldChange('accountName', event)}
      />
      {formFieldsValidation.accountName === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={4} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyFieldErrorText(
              generalStrings.registerForm.formAccountNameFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
    </FormFieldWrapper>

    {/* Account Email Field */}
    <FormFieldWrapper>
      <FormLabel>{`${generalStrings.registerForm.formAccountEmailFieldLabel}*`}</FormLabel>
      <SectionDivider gap={4} />
      <FormTextInput
        type="text"
        value={formFieldsValues.accountEmail}
        onChange={event => handleTextInputFieldChange('accountEmail', event)}
      />
      {formFieldsValidation.accountEmail === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={4} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyFieldErrorText(
              generalStrings.registerForm.formAccountEmailFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
      {formFieldsValidation.accountEmail === registerFormValidationErrorType.wrong && (
        <>
          <SectionDivider gap={4} />
          <FormValidationError>
            {generalStrings.registerForm.formWrongFieldErrorText(
              generalStrings.registerForm.formAccountEmailFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
    </FormFieldWrapper>

    {/* Account Mobile Field */}
    <FormFieldWrapper>
      <FormLabel>{`${generalStrings.registerForm.formAccountMobileNumberFieldLabel}*`}</FormLabel>
      <SectionDivider gap={4} />
      <FormTextInput
        type="number"
        value={formFieldsValues.accountMobileNumber}
        onChange={event => handleTextInputFieldChange('accountMobileNumber', event)}
      />
      {formFieldsValidation.accountMobileNumber === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={4} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyFieldErrorText(
              generalStrings.registerForm.formAccountMobileNumberFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
      {formFieldsValidation.accountMobileNumber === registerFormValidationErrorType.wrong && (
        <>
          <SectionDivider gap={4} />
          <FormValidationError>
            {generalStrings.registerForm.formWrongFieldErrorText(
              generalStrings.registerForm.formAccountMobileNumberFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
    </FormFieldWrapper>

    {/* Account Password Field */}
    <FormFieldWrapper>
      <FormLabel>{`${generalStrings.registerForm.formAccountPasswordFieldLabel}*`}</FormLabel>
      <SectionDivider gap={4} />
      <FormTextInput
        type="password"
        value={formFieldsValues.accountPassword}
        onChange={event => handleTextInputFieldChange('accountPassword', event)}
      />
      {formFieldsValidation.accountPassword === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={4} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyFieldErrorText(
              generalStrings.registerForm.formAccountPasswordFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
      {formFieldsValidation.accountPassword === registerFormValidationErrorType.wrong && (
        <>
          <SectionDivider gap={4} />
          <FormValidationError>
            {generalStrings.registerForm.formWeakPassowrdErrorText}
          </FormValidationError>
        </>
      )}
    </FormFieldWrapper>
  </FormWrapper>
);

AccountInformation.propTypes = {
  formFieldsValues: PropTypes.shape().isRequired,
  formFieldsValidation: PropTypes.shape().isRequired,
  handleTextInputFieldChange: PropTypes.func.isRequired,
};

export default AccountInformation;
